export function PhoneInput(value
) {
    return {
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        xxl: value.xxl,
        layout: value.layout,
        formWrapperStyle: value.formWrapperStyle,
        placeholder: value.placeholder,
        typeChamps: value.typeChamps,
        label: value.label,
        langue: value.langue,
        name: value.name,
        rules: value.rules,
        type: value.type,
        defaultCountry: value.defaultCountry,
        value: value.value,
        helpMessage: value.helpMessage,
        styles: value.styles,
        inputStyle: value.inputStyle,
        labelStyle: value.labelStyle,
        formItemStyles: value.formItemStyles,
        allowClear: value.allowClear,
        disabled: value.disabled,
        maxLength: value.maxLength,
        international: value.international,
    }
}
export function Inputs(value
) {
    return {
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        xxl: value.xxl,
        layout: value.layout,
        formWrapperStyle: value.formWrapperStyle,
        extra: value.extra,
        typeChamps: value.typeChamps,
        label: value.label,
        name: value.name,
        rules: value.rules,
        type: value.type,
        defautValue: value.defautValue,
        value: value.value,
        placeholder: value.placeholder,
        helpMessage: value.helpMessage,
        styles: value.styles,
        inputStyle: value.inputStyle,
        labelStyle: value.labelStyle,
        formItemStyles: value.formItemStyles,
        allowClear: value.allowClear,
        disabled: value.disabled,
        maxLength: value.maxLength,
        prefix: value.prefix,
        showCount: value.showCount,
    }
}
export function InputsArea(value
) {
    return {
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        layout: value.layout,
        extra: value.extra,
        formWrapperStyle: value.formWrapperStyle,
        label: value.label,
        typeChamps: value.typeChamps,
        name: value.name,
        rules: value.rules,
        defautValue: value.defautValue,
        value: value.value,
        placeholder: value.placeholder,
        helpMessage: value.helpMessage,
        styles: value.styles,
        inputStyle: value.inputStyle,
        labelStyle: value.labelStyle,
        formItemStyles: value.formItemStyles,
        allowClear: value.allowClear,
        disabled: value.disabled,
        maxLength: value.maxLength,
        showCount: value.showCount,
        status: value.status,
        autoSize: value.autoSize,
        rows: value.rows,
    }
}
export function ButtonsItem(value
) {
    return {
        variant: value.variant,
        icon: value.icon,
        shape: value.shape,
        iconPosition: value.iconPosition,
        rowBalise: value.rowBalise,
        id: value.id,
        colStyle: value.colStyle,
        formWrapperStyle: value.formWrapperStyle,
        formItemStyles: value.formItemStyles,
        extra: value.extra,
        typeChamps: value.typeChamps,
        text: value.text,
        size: value.size,
        onPress: value.onPress,
        type: value.type,
        styles: value.styles,
        textStyles: value.textStyles,
        labelStyle: value.labelStyle,
        activeStyle: value.activeStyle,
        disabled: value.disabled,
    }
}
export function Buttons(item,
    group
){
    let result = group!== undefined ? group : {};
    result.item = item
    return result
}
export function RadiosItem(value
) {
    return {
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        name: value.name,
        rowBalise: value.rowBalise,
        defautValue: value.defautValue,
        formWrapperStyle: value.formWrapperStyle,
        formItemStyles: value.formItemStyles,
        rules: value.rules,
        label: value.label,
        text: value.text,
        typeChamps: value.typeChamps,
        defaultChecked: value.defaultChecked,
        checked: value.checked,
        value: value.value,
        styles: value.styles,
        labelStyle: value.labelStyle,
        options: value.options,
        disabled: value.disabled,
        returnValue: value.returnValue,
    }
}
export function Radios(item, group ){
    let result = group!== undefined ? RadiosItem(group) : {};;
    result.item = item
    return result
}
export function Checkbox(value
) {
    return {
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        rowBalise: value.rowBalise,
        name: value.name,
        options: value.options,
        textStyles: value.textStyles,
        formWrapperStyle: value.formWrapperStyle,
        formItemStyles: value.formItemStyles,
        rules: value.rules,
        text: value.text,
        typeChamps: value.typeChamps,
        defaultChecked: value.defaultChecked,
        checked: value.checked,
        styles: value.styles,
        labelStyle: value.labelStyle,
        disabled: value.disabled,
    }
}
export function DatePickerItem(value
) {
    return {
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        filter: value.filter,
        defaultDate: value.defaultDate,
        format: value.format,
        renderLabel: value.renderLabel,
        name: value.name,
        formWrapperStyle: value.formWrapperStyle,
        formItemStyles: value.formItemStyles,
        label: value.label,
        rules: value.rules,
        typeChamps: value.typeChamps,
        precision: value.precision,
        value: value.value,
        styles: value.styles,
        labelStyle: value.labelStyle,
        minDate: value.minDate,
        maxDate: value.maxDate,
        itemStyle: value.itemStyle,
    }
}
export function PickerItem(value
) {
    return {
        returnValue: value.returnValue,
        xs: value.xs,
        md: value.md,
        sm: value.sm,
        lg: value.lg,
        xl: value.xl,
        data: value.data,
        mode: value.mode,
        disabled: value.disabled,
        cols: value.cols,
        renderLabel: value.renderLabel,
        name: value.name,
        formWrapperStyle: value.formWrapperStyle,
        formItemStyles: value.formItemStyles,
        label: value.label,
        rules: value.rules,
        typeChamps: value.typeChamps,
        value: value.value,
        styles: value.styles,
        labelStyle: value.labelStyle,
        itemStyle: value.itemStyle,
    }
}
export function Upload(value
) {
return {
    xs: value.xs,
    md: value.md,
    sm: value.sm,
    lg: value.lg,
    xl: value.xl,
    spinnerColor: value.spinnerColor,
    spinnerSize: value.spinnerSize,
    formWrapperStyle: value.formWrapperStyle,
    typeChamps: value.typeChamps,
    label: value.label,
    name: value.name,
    rules: value.rules,
    value: value.value,
    helpMessage: value.helpMessage,
    styles: value.styles,
    labelStyle: value.labelStyle,
    formItemStyles: value.formItemStyles,
    disabled: value.disabled,
    layout: value.layout,
}
}
export function Contries(value
) {
return {
    xs: value.xs,
    md: value.md,
    sm: value.sm,
    lg: value.lg,
    xl: value.xl,
    formWrapperStyle: value.formWrapperStyle,
    typeChamps: value.typeChamps,
    label: value.label,
    name: value.name,
    rules: value.rules,
    value: value.value,
    helpMessage: value.helpMessage,
    styles: value.styles,
    labelStyle: value.labelStyle,
    formItemStyles: value.formItemStyles,
    disabled: value.disabled,
}
}
export function NumeroEtudiant(value
) {
return {
    xs: value.xs,
    md: value.md,
    sm: value.sm,
    lg: value.lg,
    xl: value.xl,
    formWrapperStyle: value.formWrapperStyle,
    typeChamps: value.typeChamps,
    label: value.label,
    name: value.name,
    rules: value.rules,
    value: value.value,
    helpMessage: value.helpMessage,
    styles: value.styles,
    labelStyle: value.labelStyle,
    formItemStyles: value.formItemStyles,
    disabled: value.disabled,
}
}
export function TimePicker(value
) {
return {
    xs: value.xs,
    md: value.md,
    sm: value.sm,
    lg: value.lg,
    xl: value.xl,
    format: value.format,
    size: value.size,
    typeChamps: value.typeChamps,
    label: value.label,
    name: value.name,
    rules: value.rules,
    value: value.value,
    helpMessage: value.helpMessage,
    styles: value.styles,
    labelStyle: value.labelStyle,
    formItemStyles: value.formItemStyles,
    disabled: value.disabled,
}
}
export function RangePicker(value
) {
return {
    xs: value.xs,
    md: value.md,
    sm: value.sm,
    lg: value.lg,
    xl: value.xl,
    filter: value.filter,
    defaultDate: value.defaultDate,
    format: value.format,
    renderLabel: value.renderLabel,
    name: value.name,
    formWrapperStyle: value.formWrapperStyle,
    formItemStyles: value.formItemStyles,
    label: value.label,
    rules: value.rules,
    typeChamps: value.typeChamps,
    precision: value.precision,
    value: value.value,
    styles: value.styles,
    labelStyle: value.labelStyle,
    minDate: value.minDate,
    maxDate: value.maxDate,
    itemStyle: value.itemStyle,
}
}
export function CKEditor(value
) {
return {
    xs: value.xs,
    md: value.md,
    sm: value.sm,
    lg: value.lg,
    xl: value.xl,
    name: value.name,
    formWrapperStyle: value.formWrapperStyle,
    formItemStyles: value.formItemStyles,
    label: value.label,
    rules: value.rules,
    typeChamps: value.typeChamps,
    value: value.value,
    styles: value.styles,
    labelStyle: value.labelStyle,
    itemStyle: value.itemStyle,
}
}
export function Engagement(value
) {
return {
    value: value.value,
    typeChamps: value.typeChamps,
}
}
export function Text(value
) {
return {
    text: value.text,
    labelStyle: value.labelStyle,
    typeChamps: value.typeChamps,
}
}
